import React, { FC } from 'react';
import styled from 'styled-components';

import { OptionButton } from './Button';

/* MultiSelectInputOption */

// Button toggles one option in MultiSelectInput

interface MultiSelectInputOptionProps {
  label: string;
  id: string;
  selected: boolean;
  disabled: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Option = styled(OptionButton)`
  width: 100%;
  margin-bottom: 0.5rem;
  font-weight: 400;
`;
OptionButton.displayName = 'OptionButton';

const Container = styled.li`
  min-width: 50%;
  display: flex;
  &:nth-child(odd) {
    ${OptionButton} {
      margin-right: 0.25rem;
    }
  }
  &:nth-child(even) {
    ${OptionButton} {
      margin-left: 0.25rem;
    }
  }
  &:last-of-type {
    flex: 1;
    ${OptionButton} {
      margin: 0;
    }
  }
`;
Container.displayName = 'Container';

export const MultiSelectInputOption: FC<MultiSelectInputOptionProps> = ({
  label,
  id,
  selected,
  disabled,
  onClick,
}) => (
  <Container>
    <Option
      id={id}
      selected={selected}
      type="button"
      disabled={disabled}
      role="option"
      aria-labelledby={label}
      aria-selected={selected}
      onClick={onClick}
    >
      {label}
    </Option>
  </Container>
);
